import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography, Chip } from '@emburse/embark-core';
import { useMemo } from 'react';
import { ForteApplicationStatus } from '../../../api/forteApplication';
import { $t } from '../../../hooks/useTranslation';
function CompletedView({ status }) {
    const statusColor = useMemo(() => {
        switch (status) {
            case ForteApplicationStatus.Approved:
            case ForteApplicationStatus.Enrolled:
                return 'success';
            case ForteApplicationStatus.Declined:
            case ForteApplicationStatus.Rejected:
            case ForteApplicationStatus.Recalled:
                return 'error';
            case ForteApplicationStatus.Pending:
            case ForteApplicationStatus.Received:
                return 'info';
            default:
                return 'monochrome';
        }
    }, [status]);
    return (_jsxs(Stack, { sx: { width: '100%' }, spacing: 5, alignItems: "flex-start", children: [_jsx(Typography, { align: "center", variant: "h5", children: $t(`Application Complete`) }), _jsx(Typography, { variant: "subtitle2", children: $t(`Your organization's application has been submitted for review. Your team will be
                notified via email when you can begin reimbursing your employees!`) }), _jsxs(Stack, { spacing: 1, direction: "row", alignItems: "center", children: [_jsx(Typography, { variant: "subtitle2", style: { fontWeight: 'bold' }, align: "center", children: $t(`Application Status: `) }), _jsx(Chip, { label: $t(status ?? 'unsubmitted'), size: "small", color: statusColor, "data-testid": "statusChip" })] })] }));
}
export default CompletedView;
